module.exports = __webpack_public_path__ + "img/home-map-locations.10ea8bed.webp";